import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("donitshit_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
